/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76502ReqFieldConditionsItem {
  
  /** 字段名称 */
  fieldName?: string;
  
  /** 字段描述 */
  fieldDescription?: string;
  
};
    
  
    
export interface IAPI76502ReqModelTasksItemSuggestStartResultObj {
  
  /** -9之前,+9之后 */
  day?: number;
  
  /** hh:mm */
  pointTime?: string;
  
};
    
  
    
export interface IAPI76502ReqModelTasksItemSuggestEndResultObj {
  
  /** -9之前,+9之后 */
  day?: number;
  
  /** hh:mm */
  pointTime?: string;
  
};
    
  
    
export interface IAPI76502ReqModelTasksItem {
  
  /**  */
  dataId?: string;
  
  /** 版本号 */
  version?: number;
  
  /** 新版本号 */
  newVersion?: number;
  
  /** 节点ID */
  nodeId?: string;
  
  /** 父节点ID ,String */
  parentNodeIds?: string[];
  
  /** 节点名称 */
  nodeName?: string;
  
  /** 节点标签 */
  nodeTag?: string;
  
  /** 节点描述 */
  nodeDesc?: string;
  
  /** 岗位 */
  role?: string;
  
  /** 触发方式,timeTarget:时间触发,nodeStart:节点开始触发,nodeEnd：节点完成触发 */
  triggerType?: string;
  
  /** 建议开始时间 ,TimeResp */
  suggestStartResult?: IAPI76502ReqModelTasksItemSuggestStartResultObj;
  
  /** 建议结束时间 ,TimeResp */
  suggestEndResult?: IAPI76502ReqModelTasksItemSuggestEndResultObj;
  
  /** 完成任务是否需要提交 */
  completeTaskNeedSubmit?: string;
  
  /** 完成任务是否需要提交 */
  completeTaskInformation?: string;
  
  /** 操作人名称 */
  operatorName?: string;
  
  /** 操作人id */
  operatorId?: string;
  
};
    
  



export interface API76502Req {
  
  /** 任务模型id */
  dataId?: string;
  /** 版本号 */
  version?: number;
  /** 模型名称 */
  modelTaskName?: string;
  /** 模型描述 */
  modelResponsibility?: string;
  /** 任务条件要素 ,FieldCondition */
  fieldConditions?: IAPI76502ReqFieldConditionsItem[];
  /** 节点信息 ,ModelTaskSaveReq */
  modelTasks?: IAPI76502ReqModelTasksItem[];
};



export type API76502Res = {};


// 接口函数 76502 保存并发布模型

export interface IUsePostAPI76502Return {
  /** 保存并发布模型: 接口请求状态 */
  isAPI76502Loading: boolean;
  /** 保存并发布模型: 接口请求返回数据 */
  dataAPI76502: API76502Res;
  /**  保存并发布模型: 接口数据请求方法 */
  fetchAPI76502Data: (inputs: API76502Req, config?: YWRequestConfig) => Promise<API76502Res>;
  /** 保存并发布模型: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI76502 = ():IUsePostAPI76502Return => {
  let isMount = true;
  const [isAPI76502Loading, setIsAPI76502Loading] = useState(false);
  const [dataAPI76502, setDataAPI76502] = useState<API76502Res>({} as API76502Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/publish/model`;

  const fetchAPI76502Data = async (inputs: API76502Req, config?: YWRequestConfig): Promise<API76502Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76502Req>) || {}) as API76502Req;
    
  
    if ( isMount ) {
      setIsAPI76502Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API76502Res>(`${basePath}/yoaichat-web/chat/task/model/publish/model`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI76502(res || {} as API76502Res);
        setIsAPI76502Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76502Loading(false);
      }
      return false as unknown as API76502Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76502Loading,
    dataAPI76502,
    fetchAPI76502Data,
    requestUrl,
  }
}

